import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { map, mergeMap, retryWhen } from 'rxjs/operators';
import { ValidationResultModel } from '../../../shared/models/validation-results/validation-result.model';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';

@Injectable()
export class IncidentConfirmationService {
    constructor(
        private modalService: MvdModalService,
        private router: Router) {
    }

    public confirmIncident = (incidentCallback: (validationResult: ValidationResultModel) => void) => (source: Observable<any>) => {
        let firstError = true;

        return source.pipe(
            retryWhen(errors => errors.pipe(mergeMap((e: HttpErrorResponse) => {
                if (false == firstError) {
                    return observableThrowError(e);
                }

                firstError = false;
                let r: any = e.error;
                let confirmationErrors = r.validationResults.filter(i => 'CONFIRM_ADMINISTRATIVE_ACTION' == i.state.errorCode);

                if ((null != confirmationErrors) && (0 != confirmationErrors.length)) {
                    let error = confirmationErrors[0];
                    return this.modalService.confirm()
                        .title('Confirm')
                        .body(error.errorMessage)
                        .okBtn('Continue')
                        .cancelBtn('Cancel')
                        .open()
                        .afterClosed()
                        .pipe(map(result => {
                            if (result) {
                                try {
                                    incidentCallback(error);
                                } catch {
                                    return observableThrowError(e);
                                }
                            }
                        }));
                }

                return observableThrowError(e);
            }))));
    };

    public confirmIncidentRedirect = (bussinessTransactionId: number, result: any, dialogRef: any = null): void => {
        // Make sure result and validation result are not null
        if (result && result.validationResults) {
            let redirectErrors = result.validationResults.filter(i => 'REDIRECT_ADMINISTRATIVE_ACTION' == i.state.errorCode);

            if ((null != redirectErrors) && (0 != redirectErrors.length)) {
                let error = redirectErrors[0];

                this.modalService.alert()
                    .title('Create Incident')
                    .body(error.errorMessage)
                    .okBtn('Continue')
                    .open()
                    .afterClosed()
                    .subscribe(result => {
                        if (result) {
                            try {
                                if (bussinessTransactionId != null) {
                                    // Show back button in incident creation
                                    this.router.navigate(['/incident/direct/', error.state.customerNumberId, error.state.requestedValue, bussinessTransactionId]);
                                } else {
                                    // Dont show back button
                                    this.router.navigate(['/incident/direct/', error.state.customerNumberId, error.state.requestedValue]);
                                }
                            } catch (error) {
                                console.error(error);
                            }
                        }

                        if (dialogRef) {
                            dialogRef.close(true);
                        }
                    });
            }
        }
    };
}
